import {
    RED,
    GREEN,
    YELLOW
} from './CompilerColors';

export const FAIL = RED('×');

export const WARN = YELLOW('✓');

export const SUCCESS = GREEN('✓');
